import { useLang } from "../context/LanguageContext";
import { IMAGES } from "../data/content";
import { Reveal } from "./Reveal";

const Tag = ({ children }) => (
  <span className="inline-block text-xs font-semibold uppercase tracking-widest text-primary mb-5">{children}</span>
);

export const About = () => {
  const { t } = useLang();
  const a = t.about;
  return (
    <section id="about" className="py-24 md:py-32 relative z-10">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
        <div className="lg:col-span-7">
          <Reveal><Tag>{a.tag}</Tag></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display font-extrabold tracking-tight text-4xl md:text-6xl leading-[1.02] mb-8">
              {a.title}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-base md:text-lg text-muted-foreground leading-relaxed max-w-xl mb-5">{a.body}</p>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="text-base md:text-lg text-muted-foreground leading-relaxed max-w-xl">{a.body2}</p>
          </Reveal>

          <div className="mt-12 grid grid-cols-3 gap-6 max-w-xl">
            {a.stats.map((s, i) => (
              <Reveal key={i} delay={0.1 + i * 0.08}>
                <div className="border-t border-foreground/15 pt-4">
                  <div className="font-display font-extrabold text-3xl md:text-4xl tracking-tight">{s.n}</div>
                  <div className="text-xs md:text-sm text-muted-foreground mt-1">{s.l}</div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5">
          <Reveal delay={0.1}>
            <div className="rounded-3xl overflow-hidden aspect-[4/5] border border-black/5 group">
              <img src={IMAGES.family} alt="" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export const Mission = () => {
  const { t } = useLang();
  const m = t.mission;
  return (
    <section className="py-24 md:py-32 bg-primary text-primary-foreground relative z-10">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal><span className="text-xs font-semibold uppercase tracking-widest text-accent mb-10 block">{m.tag}</span></Reveal>
        <div className="grid md:grid-cols-2 gap-12 md:gap-20">
          <Reveal delay={0.05}>
            <div>
              <h3 className="font-serif-ed italic text-3xl md:text-4xl mb-5">{m.missionTitle}</h3>
              <p className="text-base md:text-lg text-primary-foreground/80 leading-relaxed">{m.mission}</p>
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <div>
              <h3 className="font-serif-ed italic text-3xl md:text-4xl mb-5">{m.visionTitle}</h3>
              <p className="text-base md:text-lg text-primary-foreground/80 leading-relaxed">{m.vision}</p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export const Manifesto = () => {
  const { t } = useLang();
  const m = t.manifesto;
  return (
    <section id="manifesto" className="py-24 md:py-32 relative z-10">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="max-w-2xl mb-16">
          <Reveal><Tag>{m.tag}</Tag></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display font-extrabold tracking-tight text-4xl md:text-6xl leading-[1.02]">{m.title}</h2>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12">
          {m.values.map((v, i) => (
            <Reveal key={i} delay={(i % 4) * 0.08}>
              <div className="group relative">
                <div className="font-display font-light text-7xl md:text-8xl text-primary/10 leading-none mb-2 transition-colors group-hover:text-primary/25">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <h3 className="font-display font-bold text-xl md:text-2xl tracking-tight mb-2">{v.t}</h3>
                <p className="text-sm md:text-base text-muted-foreground leading-relaxed">{v.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
